export default __webpack_public_path__ + "static/media/AIRFRANCE_2.6dc4e926.gif";